module.exports = __webpack_public_path__ + "static/media/653.5febf641.webp";